import React, { Component } from "react";
import {
  Form,
  FormGroup,
  Input,
  Modal,
  Alert,
  Button,
  Table
} from "reactstrap";
import myFetchWithId from "../../../helpers/myFetch";
import Loader from "react-loader-advanced";

const spinner = (
  <div className="lds-ripple">
    <div></div>
    <div></div>
  </div>
);

const removeDuplicate = (arr) =>{
  return [...new Set(arr.map(item => JSON.stringify(item)))].map(item => JSON.parse(item));
}

export class SearchChannel extends Component {
  constructor() {
    super();
    this.state = {
      chName: "",
      emptyAlert: false,
      open: false,
      loading: false,
      noContentLoading: false,
      selectedAll:false,
      chSelected: [],
      selectedKey: [],
      searchResult: []
    };
  }

  toggleOpen = () => {
    this.setState(prevState => ({ open: !prevState.open }));
  };

  changeChName = e => {
    this.setState({ chName: e.target.value });
  };

  search = () => {
    const chName = this.state.chName;

    if(this.state.searchResult.length>0){
      this.setState({ showError: false, loading: true, selectedAll:false });
    }
    else{
      this.setState({ showError: false, noContentLoading: true, selectedAll:false });
    }
    
    if (chName.length === 0) {
      this.setState({ emptyAlert: true });
    } else {
      const normalFetch = myFetchWithId("", true, true);
      try {
        normalFetch(`/v5/lowi3/q/get_source_channel`, {
          text: chName
        }).then(data => {
          this.setState({
            searchResult: data.value,
            loading: false,
            noContentLoading: false,
          },()=>{console.log(data)});
          
        });
      } catch (err) {
        console.log('catch error : '+err)
        this.setState({ showError: true, loading: false });
      }
    }
  };

  selectCh = (ch) => {
    const { chSelected, selectedKey } = this.state;
    const selectedIndex = selectedKey.indexOf(ch.key);

    if (selectedIndex < 0) {
      chSelected.push(ch);
      selectedKey.push(ch.key);
    } else {
      chSelected.splice(selectedIndex, 1);
      selectedKey.splice(selectedIndex, 1);
    }

    this.setState({chSelected: chSelected, selectedKey: selectedKey});
  }

  select = (chList) => {
    this.setState({open: false});
    this.props.select(chList);
  }
  
  selectAll =()=>{
    if(this.state.selectedAll){
      this.setState({
        chSelected:[],
        selectedKey:[],
        selectedAll:!this.state.selectedAll
      })
    }
    else{
      const preSelect = this.props.selectChannel
      const all = this.state.searchResult.map((item) =>{return {
        key:item.GLB_CHANNEL_KEY,
        name:item.GLB_CHANNEL_LV1,
        source:item.GLB_SOURCE,
        type:item.GLB_TYPE,
      }})

      const allkey =this.state.searchResult.map((item)=>item.GLB_CHANNEL_KEY)
      
      this.setState({
        selectedAll:!this.state.selectedAll,
        chSelected:removeDuplicate(all.concat(preSelect)),
        selectedKey:removeDuplicate(allkey.concat(preSelect.map(item => item.key))),
      })
    }
  }

  render() {
    const { chName, emptyAlert, open, searchResult, loading, chSelected, selectedKey,noContentLoading } = this.state;
    return (
      <React.Fragment>
        <Button color="primary" onClick={this.toggleOpen}>
          搜尋子板
        </Button>
        <Modal size="mid" isOpen={open} toggle={this.toggleOpen}>
          <div className="popup-modal">
            <div className="popup-modal-header">
              <h3>搜尋子板</h3>
            </div>
            <Loader style={{width : '100%'}} show={noContentLoading} message={spinner} hideContentOnLoad={true}>
              <div className="popup-modal__search-bar">
                <Form>
                  <FormGroup>
                    {emptyAlert && (
                      <Alert color="danger">請輸入要搜尋的子板名稱</Alert>
                    )}
                    <Input
                      type="text"
                      id="widgetName"
                      value={chName}
                      onChange={this.changeChName}
                    />
                  </FormGroup>
                </Form>
                  <Button
                    color="primary"
                    className="popup-modal__search-bar__button"
                    onClick={this.search}
                  >
                    搜尋
                  </Button>
              </div>
            </Loader>
            <div className="popup-modal__search-result">
              <Loader show={loading} message={spinner} hideContentOnLoad={true}>
              {searchResult.length > 0 &&
                <React.Fragment>
                <div className="popup-modal__search-result__body">
                  <Table bordered hover>
                    <thead>
                      <tr>
                        <th className="head checkbox">
                        全選
                        <input
                        className="select-media-type"
                        type="checkbox"
                        checked={this.state.selectedAll}
                        onChange={() => {
                          this.selectAll();
                        }}
                      />
                        </th>
                        <th className="head vibe">子板名稱</th>
                        <th className="title">所屬頻道</th>
                        <th className="head count">所屬類型</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResult.map((obj, i) =>
                        <tr key={i}>
                          <td className='checkbox'>
                            <input 
                              type="checkbox" 
                              checked={selectedKey.indexOf(obj.GLB_CHANNEL_KEY) !== -1} 
                              onChange={() => {this.selectCh(
                                {
                                key: obj.GLB_CHANNEL_KEY,
                                name: obj.GLB_CHANNEL_LV1,
                                source: obj.GLB_SOURCE,
                                type: obj.GLB_TYPE
                              }
                              )}}
                            />
                          </td>
                          <td>{obj.GLB_CHANNEL_LV1}</td>
                          <td>{obj.GLB_SOURCE}</td>
                          <td>{obj.GLB_TYPE}</td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
                <div className="popup-modal__search-result__control">
                  <Button color="primary" onClick={() => {this.select(chSelected)}}>
                    套用選取的子板
                  </Button>
                </div>
                </React.Fragment>
                }
              </Loader>
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/popup/mediasComponents/myMediaList.js